import { phoneVerification } from '@/utils/verification'
import { shopTypeList } from '@/utils/dict.js'
const validPhone = (rule, value, callback) => {
  if (value && !phoneVerification(value)) {
    callback(new Error('手机号格式不正确'))
  } else {
    callback()
  }
}

export const SEARCH_CONFIGS = [
  {
    key: ['filterObj', 'target'],
    searchType: 'selectInput',
    componentData: {
      options: [
        { label: window.$t('customer::customer-list::email'), value: 'userEmail' },
        { label: window.$t('customer::customer-list::customer_name'), value: 'userName' },
        { label: window.$t('customer::customer-list::phone_number'), value: 'phone' }
      ],
      inputComponentData: {
        maxlength: 50
      }
    }
  },
  // {
  //   label: window.$t('customer::customer-list::customer_level'),
  //   key: 'customerLevel',
  //   searchType: 'select',
  //   componentData: {
  //     placeholder: window.$t('customer::customer-list::customer_level'),
  //     options: [],
  //     filterable: true,
  //     clearable: true,
  //     multiple: true,
  //     collapseTags: true
  //   }
  // },
  {
    // label: window.$t('customer::customer-list::tag'),
    key: 'userType',
    searchType: 'select',
    componentData: {
      style: { width: '220px' },
      placeholder: window.$t('customer::customer-list::tag'),
      options: [
        {
          label: '非付费新客户',
          value: '非付费新客户'
        },
        {
          label: '付费新客户',
          value: '付费新客户'
        },
        {
          label: '非付费复购客户',
          value: '非付费复购客户'
        },
        {
          label: '付费复购客户',
          value: '付费复购客户'
        },
        {
          label: '多渠道复购客户',
          value: '多渠道复购客户'
        },
        {
          label: '流失客户',
          value: '流失客户'
        }
      ],
      filterable: true,
      clearable: true,
      multiple: true,
      collapseTags: true
    }
  },
  {
    // label: window.$t('customer::customer-list::join_time'),
    key: 'time',
    searchType: 'selectDatepicker',
    componentData: {
      options: [
        {
          label: window.$t('customer::customer-list::join_time'),
          value: 'createTime',
          keys: ['startJoinTime', 'endJoinTime']
        }
      ],
      dateComponentData: {
        startPlaceholder: window.$t('customer::customer-list::join_time'),
        endPlaceholder: window.$t('customer::customer-list::end_time')
      }
    }
  },
  {
    // label: window.$t('customer::customer-list::consume'),
    key: ['minAmount', 'maxAmount'],
    searchType: 'numberRange',
    componentData: {
      startPlaceholder: window.$t('customer::customer-list::min_consume'),
      endPlaceholder: window.$t('customer::customer-list::max_consume')
    }
  },
  {
    // label: window.$t('customer::customer-list::order_quantity'),
    key: ['minOrderNum', 'maxOrderNum'],
    searchType: 'numberRange',
    componentData: {
      startPlaceholder: window.$t('customer::customer-list::order_quantity_min'),
      endPlaceholder: window.$t('customer::customer-list::order_quantity_max')
    }
  }
]

export const CUSTOMER_COLUMNS = [
  {
    prop: 'userEmail',
    label: window.$t('customer::customer-list::email'),
    fixed: 'left',
    minWidth: 220
  },
  {
    prop: 'userName',
    label: window.$t('customer::customer-list::customer_name'),
    minWidth: 200,
  },
  {
    prop: 'phone',
    label: window.$t('customer::customer-list::phone_number'),
    width: 180
  },
  {
    prop: 'orderNum',
    label: window.$t('customer::customer-list::order_quantity'),
    width: 150
  },
  {
    prop: 'ltv',
    label: window.$t('customer::customer-list::total_spending'),
    width: 180
  },
  // {
  //   prop: 'refundOrderCount',
  //   label: window.$t('customer::customer-list::after_sales_order'),
  //   width: 120
  // },
  // {
  //   prop: 'customerLevelName',
  //   label: window.$t('customer::customer-list::customer_level'),
  //   width: 120
  // },
  {
    prop: 'joinTime',
    label: window.$t('customer::customer-list::join_time'),
    width: 210
  },
  {
    prop: 'lastOrderTime',
    label: '最近下单时间',
    width: 210
  },
  // {
  //   prop: 'acceptsMarketing',
  //   label: window.$t('customer::customer-list::subscribe_time'),
  //   width: 120
  // },
  {
    prop: 'operate',
    label: window.$t('customer::customer-list::opt'),
    fixed: 'right',
    width: 120
  }
]

export const MARKETING_COLUMNS = [
  {
    prop: 'name',
    label: window.$t('customer::customers-notice::activity_name'),
    fixed: 'left',
    minWidth: 130
  },
  {
    prop: 'filter',
    label: window.$t('customer::customers-notice::recipient'),
    minWidth: 150
  },
  {
    prop: 'sentDate',
    label: window.$t('customer::customers-notice::send_time'),
    minWidth: 200
  },
  {
    prop: 'status',
    label: window.$t('customer::customers-notice::status'),
    minWidth: 100
  },
  {
    prop: 'updateTime',
    label: window.$t('customer::customers-notice::update_time'),
    minWidth: 200
  },
  {
    prop: 'operate',
    label: window.$t('customer::customers-notice::opt'),
    fixed: 'right',
    width: '180'
  }
]

export const SEND_STATUS = {
  3: { type: 'success', label: window.$t('customer::customers-notice::send_success') },
  2: { type: 'warning', label: window.$t('customer::customers-notice::sending') },
  1: { type: '', label: window.$t('customer::customers-notice::wait_send') },
  0: { type: 'info', label: window.$t('customer::customers-notice::draft') }
}

export const formRules = {
  firstName: [{ required: true, message: window.$t('customer::customer-list::last_name_input'), trigger: 'blur' }],
  lastName: [{ required: true, message: window.$t('customer::customer-list::first_name_input'), trigger: 'blur' }],
  email: [
    { required: true, message: window.$t('customer::customer-list::email_input'), trigger: 'blur' },
    { type: 'email', message: window.$t('customer::customer-list::email_input_correct') }
  ],
  phone: [{ validator: validPhone, trigger: 'blur' }]
}

// 购物历史-搜索栏
export function getHistoryConfig(shopList = []) {
  return [
    // {
    //   label: window.$t('customer::customer-list::belong_platform'),
    //   key: 'mallType',
    //   searchType: 'select',
    //   componentData: {
    //     placeholder: window.$t('customer::customer-list::belong_platform'),
    //     filterable: true,
    //     clearable: true,
    //     options: shopTypeList
    //   }
    // },
    {
      key: 'shopId',
      label: window.$t('customer::customer-list::belong_shop'),
      searchType: 'select',
      componentData: {
        cache: false,
        dictKey: 'shop_id',
        placeholder: window.$t('customer::customer-list::belong_shop'),
        filterable: true,
        clearable: true,
        options: shopList
      }
    },
    {
      label: window.$t('customer::customer-list::create_time'),
      key: 'createTime',
      searchType: 'selectDatepicker',
      componentData: {
        options: [
          {
            label: window.$t('customer::customer-list::create_time'),
            value: 'createTime',
            keys: ['startCreateDate', 'endCreateDate']
          }
        ],
        dateComponentData: {
          startPlaceholder: window.$t('customer::customer-list::create_begin_time'),
          endPlaceholder: window.$t('customer::customer-list::create_end_time')
        }
      }
    },
    {
      label: window.$t('customer::customer-list::pay_time'),
      key: 'payTime',
      searchType: 'selectDatepicker',
      componentData: {
        options: [
          {
            label: window.$t('customer::customer-list::pay_time'),
            value: 'payTime',
            keys: ['startPayDate', 'endPayDate']
          }
        ],
        dateComponentData: {
          startPlaceholder: window.$t('customer::customer-list::pay_start_time'),
          endPlaceholder: window.$t('customer::customer-list::pay_end_time')
        }
      }
    },
    {
      label: window.$t('customer::customer-list::deal_amount'),
      key: ['minAmount', 'maxAmount'],
      searchType: 'numberRange',
      componentData: {
        startPlaceholder: window.$t('customer::customer-list::deal_amount_min'),
        endPlaceholder: window.$t('customer::customer-list::deal_amount_max')
      }
    }
  ]
}

// 购物历史-表格
export const historyColumns = [
  {
    prop: 'orderNo',
    label: window.$t('customer::customer-list::shop_order_num'),
    minWidth: 180
  },
  // {
  //   prop: 'mallType',
  //   label: window.$t('customer::customer-list::belong_platform'),
  //   minWidth: 150
  // },
  {
    prop: 'brandName',
    label: window.$t('customer::customer-list::belong_shop'),
    minWidth: 150
  },
  {
    prop: 'qty',
    label: window.$t('customer::customer-list::prod_num'),
    minWidth: 150
  },
  {
    prop: 'grandTotalUsd',
    label: window.$t('customer::customer-list::order_total'),
    minWidth: 150
  },
  {
    prop: 'orderStatus',
    label: window.$t('customer::customer-list::order_status'),
    minWidth: 150
  },
  {
    prop: 'createTime',
    label: window.$t('customer::customer-list::create_time'),
    minWidth: 200
  },
  {
    prop: 'payTime',
    label: window.$t('customer::customer-list::pay_time'),
    minWidth: 200
  },
  {
    prop: 'payType',
    label: window.$t('customer::customer-list::pay_type'),
    minWidth: 150
  },
  {
    prop: 'payStatus',
    label: window.$t('customer::customer-list::pay_status'),
    minWidth: 150
  },
  {
    prop: 'shippingStatus',
    label: window.$t('customer::customer-list::fullfillment_status'),
    minWidth: 150
  }
]

export const STEP_STAUTS = {
  0: window.$t('customer::customer-list::zero_time'),
  1: window.$t('customer::customer-list::one_time'),
  2: window.$t('customer::customer-list::one_time_more'),
  3: window.$t('customer::customer-list::two_time_more')
}
